import {IFilterCategoryDefinitionFactory} from "./filter-category-definition-factory.interface";
import {CategoryDefinitionId, IFilterCategoryDefinition} from "./filter-category-definition.interface";
import {VolatilityFiltersCategoryDefinition} from "./volatility.filters-category-definition";
import {GameFeaturesFiltersCategoryDefinition} from "./game-features.filters-category-definition";
import {HasJackpotFiltersCategoryDefinition} from "./has-jackpot.filters-category-definition";
import {GameVendorFiltersCategoryDefinition} from "./game-vendor.filters-category-definition";
import {GameGroupFiltersCategoryDefinition} from "./game-group.filters-category-definition";
import {IServiceFactoryExtended} from "../../service-factory-extended.interface";

import {GameThemeFiltersCategoryDefinition} from "./game-theme.filters-category-definition";

export class FilterCategoryDefinitionFactory implements IFilterCategoryDefinitionFactory {
    constructor(protected readonly services: IServiceFactoryExtended) {
    }

    private readonly _allCategories: Record<string, IFilterCategoryDefinition> = {
        "volatility": new VolatilityFiltersCategoryDefinition(this.services),
        "features": this.createGameFeaturesCategoryDefinition(),
        "hasJackpot": new HasJackpotFiltersCategoryDefinition(this.services),
        "themes": new GameThemeFiltersCategoryDefinition(this.services),
        "vendors" : this.createVendorsCategoryDefinition(),
        "gameGroups": this.createGameGroupCategoryDefinition(),
    };

    createCategoryDefinition(categoryDefinitionId: CategoryDefinitionId): IFilterCategoryDefinition | null {
        if (categoryDefinitionId in this._allCategories) {
            return this._allCategories[categoryDefinitionId];
        } else {
            this.services.logger.error(`There is no filters category definition for id ${categoryDefinitionId}`);
            return null;
        }
    }
    

    createVendorsCategoryDefinition(): IFilterCategoryDefinition {
        return new GameVendorFiltersCategoryDefinition(this.services);
    }

    createGameGroupCategoryDefinition(): IFilterCategoryDefinition {
        return new GameGroupFiltersCategoryDefinition(this.services);
    }

    createGameFeaturesCategoryDefinition(): IFilterCategoryDefinition {
        return new GameFeaturesFiltersCategoryDefinition(this.services);
    }

    getAllCategoryDefinitions(): IFilterCategoryDefinition[] {
        return Object.values(this._allCategories);
    }
}
